// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1tuqt","disabled":"FileBtn_disabled__3_V2E","warn":"FileBtn_warn__1Pq6f","fade":"FileBtn_fade__3fV5G"};